import React, { useState, useEffect } from "react";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import { NO_IMG } from "../../../assets/images/images";
import { Product } from "../../../modals/Product";
import { isValidImageUrl } from "../../../utils/common";
import { productType } from "../../../utils/constants";
import { history } from "../../../utils/appConfig";
import { MODULES } from "../../../utils/routesNames";
//for add to cart
import ListingWidget from "../../AddToCartForm/ListingWidget";
import { ProductDetails } from "../../../modals/Product";
import { GetProductDetailsService } from "../../../services/services";
import { generalMessages as MSG } from "../../../utils/constants";

interface ParentProps {
  deleteItem: Function;
  moveItem: Function;
  loadItem: Function;
}

const SavedProduct: React.FC<Product & ParentProps> = ({
  type,
  product_image,
  product_name,
  product_price,
  deleteItem,
  moveItem,
  loadItem,
  product_id,
  out_of_stock,
  product_model,
  units_per_carton,
  allergen_images,
  description,
  rw_price,
  is_cut_off_time_completed
}) => {
  const [image, setImage] = useState(product_image);
  const [product, setProduct] = useState<ProductDetails>();
  const [status, setStatus] = useState<string | null>(null);

  // useEffect(() => {
  //   getProjectDetails(product_id);
  // }, []); // eslint-disable-line

  const getProjectDetails = async (product_id: number) => {
    const result = await GetProductDetailsService(product_id.toString());
    if (result.data.flag && result.data.data.length !== 0) {
      setProduct(result.data.data);
    } else {
      setStatus(MSG.PRODUCT_NOT_FOUND);
    }
  };

  const handleSelect = (value) => {
    if (value === "move") {
      moveItem();
    } else {
      deleteItem();
    }
  };

  return (
    <div className={`product-list-item hide-arrow-${product_id}`}>
      <style>
        {`
          .hide-arrow-${product_id} .product-list-item-detail::before {
            display: none !important;
          }
        `}
      </style>
      <i className="product-list-item-img">
        <img
          onError={() => setImage(NO_IMG)}
          src={isValidImageUrl(product_image) ? product_image : NO_IMG}
          alt={product_image}
        />
      </i>
      <div className="product-list-item-detail">
        <div className="product-list-detail">
          <div>
            <div
              className="label-action"
              onClick={() => {
                loadItem();
                // history.push(
                //   `${MODULES.allProducts.url}${MODULES.productDetails.url}/${product_id}`
                // );
              }}
            >
              {product_model && (
                <p className="product-model">Product Code: {product_model}</p>
              )}

              <span>
                {product_name}
                <DropdownButton
                  onSelect={handleSelect}
                  onClick={(e) => e.stopPropagation()}
                  title=""
                  className="default-menu btn-more"
                >
                  <Dropdown.Item eventKey="move">
                    {type === productType.OCCASIONALLY
                      ? "Move to Commonly Ordered Product"
                      : "Move to Occasionally Ordered Product"}
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="delete">Delete Item</Dropdown.Item>
                </DropdownButton>
              </span>
            </div>
            {allergen_images.length > 0 && (
              <div className="d-flex align-items-center flex-wrap mb-3 gap-1">
                {allergen_images.map((icon, index) => ( 
                    <img
                      key={index}
                      src={icon}
                      alt={`allergen-${index}`}
                      onError={(e) => (e.currentTarget.src = NO_IMG)}
                      className="img-fluid rounded mr-2"
                      style={{ width: "30px", height: "30px", objectFit: "contain" }}
                    />
                  )
                )}
              </div>
            )}
            <div className="d-flex">
              <span>$ {product_price} {(product_name.toLowerCase().startsWith("rw") || description.toLowerCase().startsWith("rw")) && "/ 1 Kg"}</span>
              {rw_price && <span className="rw_price ml-4">est. ${rw_price} Pack</span>}
            </div>
          </div>
          <Form.Group className="ml-md-auto form-group">
            <ListingWidget
              id={product_id}
              is_saved={0}
              isListing
              out_of_stock={out_of_stock}
              units_per_carton={units_per_carton}
            />
          </Form.Group>
        </div>
        {is_cut_off_time_completed && <p className="cutoff-time-message">Today's order cutoff has passed, earliest delivery time is the day after tomorrow</p>}
      </div>
    </div>
  );
};

export default SavedProduct;
